/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentSourceType = {
    ach_credit_transfer: 'ach_credit_transfer',
    ach_debit: 'ach_debit',
    acss_debit: 'acss_debit',
    alipay: 'alipay',
    au_becs_debit: 'au_becs_debit',
    bancontact: 'bancontact',
    card: 'card',
    card_present: 'card_present',
    eps: 'eps',
    giropay: 'giropay',
    ideal: 'ideal',
    klarna: 'klarna',
    multibanco: 'multibanco',
    p24: 'p24',
    sepa_credit_transfer: 'sepa_credit_transfer',
    sepa_debit: 'sepa_debit',
    sofort: 'sofort',
    three_d_secure: 'three_d_secure',
    wechat: 'wechat'
} as const;
export type PaymentSourceType = typeof PaymentSourceType[keyof typeof PaymentSourceType];


export function PaymentSourceTypeFromJSON(json: any): PaymentSourceType {
    return PaymentSourceTypeFromJSONTyped(json, false);
}

export function PaymentSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSourceType {
    return json as PaymentSourceType;
}

export function PaymentSourceTypeToJSON(value?: PaymentSourceType | null): any {
    return value as any;
}

